<template>
  <div class="login-box">
      <div class="login-box-b">
          <div class="box-qrcode-title">微信登录</div>
          <div v-loading="loading">
              <img :src="codeUrl" class="box-qrcode"/> 
          </div>
          <div class="box-qrcode-state">请用微信扫码二维码登录</div>
      </div>
  </div>
</template>

<script>
import idaas from "@/apis/idaas";
export default {
  data() {
    return {
        loginForm: {},
        codeUrl:"",
        loading: true,
    };
  },
  created() {
    // this.getCode();
    this.loginForm.state = this.$route.query.state;
    idaas.getQrCodeImg(this.$route.query.connId).then(res => {
        this.codeUrl =  "data:image/png;base64," + res.data.image;
        this.loading = false
        let timer =setInterval(()=>{
            idaas.getQrCodeLogin(this.loginForm.state,res.data.ticket).then(loginRes=>{
                if (loginRes.data.url!=""){
                    clearInterval(timer)
                    location.href = loginRes.data.url
                }   
            })
        },5000)
    })
  },
};
</script>

<style scoped>
.login-box{
    height: 100%;
     display: flex;
     justify-content: center;
     align-items: center;
     height: 100vh;
     background-color: #f5f6f7;
}
.login-box-b{
    height: 441px;
    width: 380px;
    /* background-color: blue; */
    box-shadow: 0px 0px 10px rgba(213, 208, 208, 0.9);
    border-radius: 20px;
    text-align: center;
    padding: 36px 0 38px;
}
.box-qrcode-title{
    font-size: 20px;
    padding-bottom: 5px;
    color: #44b549;
}
.box-qrcode{
    height: 280px;
    width: 280px;
}
.box-qrcode-state{
    font-size: 13px;
    color: #737c84;
    padding-top: 5px;
}
</style>
